import {
  stopLayerStopType
} from "../../core-utils/src/types";
import PropTypes from "prop-types";
import React, {useState} from "react";

import {Marker, Popup} from "react-map-gl";
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import {connect} from 'react-redux'
import { rememberStop, setLocation} from "../../../actions/map";
import i18n from "../../../../i18nSetup";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

function DefaultStopMarker(props) {
  const {markerStyle, stop, rememberStop} = props;

  const [isOpenPopup, setOpenPopup] = useState(false);
  const addToFavorite = () => {
    rememberStop(stop);
  };

  const setLocationStop = (locationType) => {
    const location = {
      name: stop.name,
      lat: stop.lat,
      lon: stop.lon
    };

    props.setLocation({locationType, location, reverseGeocode: true})
  };

  const onMarkerClick = (e) => {
    setOpenPopup(true);
    e.stopPropagation();
  };

  return (
    <>
      <Marker
        longitude={stop.lon}
        latitude={stop.lat}
        anchor={ 'center'}
      >
        <Box sx={markerStyle} onClick={onMarkerClick}/>
      </Marker>
      {
        isOpenPopup && <Popup longitude={stop.lon ?? null}
                              latitude={stop.lat ?? null}
                              closeOnMove={true}
                              closeOnClick={true}
                              onClose={(e) => {setOpenPopup(false)}}
                              maxWidth='400px'
        >
          <Box>
            <Typography color="textPrimary" align={"center"}>
              {stop.code ? (stop.code + ' | ') : ''}{stop.name}
            </Typography>
            <div>
              <ButtonGroup size="small" variant="text" color="primary" aria-label="text primary button group">
                <Button sx={{textTransform: 'lowercase'}} onClick={() => {
                  setLocationStop('from')
                }}>{i18n.t('planTripFrom')}</Button>
                <Button sx={{textTransform: 'lowercase'}} onClick={() => {
                  setLocationStop('to')
                }}>{i18n.t('planTripTo')}</Button>
                <Button sx={{textTransform: 'lowercase'}}
                        onClick={addToFavorite}>{i18n.t('addStopFavourite')}</Button>
              </ButtonGroup>
            </div>
          </Box>
        </Popup>
      }
    </>
  );
}

DefaultStopMarker.propTypes = {
  style: PropTypes.object,
  radius: PropTypes.number,
  stop: stopLayerStopType.isRequired,
  rememberStop: PropTypes.func,
  setLocation: PropTypes.func,
};

DefaultStopMarker.defaultProps = {
  style: {
    color: "#000",
    width: 8,
    height: 8,
    borderRadius: '100%',
    border: '3px solid',
    boxShadow: '0px 4px 4px rgb(0 0 0 / 25%)',
    background: '#FFFFFF',
    display: 'flex',
    cursor: 'pointer'
  },
  radius: 6
};

const mapStateToProps = (state, ownProps) => {
  return {}
};

const mapDispatchToProps = {
  rememberStop,
  setLocation
};

export default connect(mapStateToProps, mapDispatchToProps)(DefaultStopMarker)
